"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    host: 'https://{prefix}.infura.io/',
    bsc: 'https://bsc-dataseed.binance.org/',
    bscTest: 'https://data-seed-prebsc-1-s2.binance.org:8545/',
    avalanche: 'https://api.avax.network/ext/bc/C/rpc/',
    avalancheTest: 'https://api.avax-test.network/ext/bc/C/rpc/',
    kaia: 'https://public-en.node.kaia.io/',
    kaiaTest: 'https://public-en.kairos.node.kaia.io/',
    bifrost: 'https://public-01.mainnet.thebifrost.io/rpc',
    bifrostTest: 'https://public-01.testnet.thebifrost.io/rpc',
    pilabPoa2: 'http://box.stage.thebifrost.io:8500/',
    pilabFork: 'http://192.168.0.155:8889/',
    sepolia: 'https://rpc.sepolia.org',
    sepoliaBase: 'https://base-sepolia.blockpi.network/v1/rpc/public',
    sepoliaArbitrum: 'https://arbitrum-sepolia.blockpi.network/v1/rpc/public',
    path: {
        network: 'v3/{projectID}',
        ipfs: 'ipfs/'
    }
};
//# sourceMappingURL=infura.js.map